<template>
    <v-btn
        class="positive-action-button btn"
        variant="flat"
        :disabled="isDisabled"
        :data-id-e2e="dataIdE2e"
        @click.stop="onClick"
    >
        <slot />
    </v-btn>
</template>

<script>
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [readonly],
    props: {
        dataIdE2e: String,
        preventDefault: Boolean,
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    emits: ['onClick'],
    computed: {
        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },
    methods: {
        onClick() {
            if (!this.disabled && !this.preventDefault) this.$emit('onClick');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.positive-action-button {
    background-color: $positive-action !important;
    color: $promo-white;
    padding: 0 1.2rem !important;
    height: 2rem !important;

    &.v-btn--size-default {
        height: 2rem !important;
    }

    &:hover {
        &.v-btn--size-default {
            background-color: $rtls-action-button-hover-colour !important;
        }
    }

    &.v-btn--disabled:not(.v-btn--variant-plain):not(.v-btn--variant-text):not(.v-btn--variant-outlined) {
        background-color: $rtls-action-button-disabled-colour !important;
        color: $promo-white !important;
    }

    :deep(.v-btn__content) {
        color: $promo-white !important;
    }
}
</style>
